import { render } from "./AdminPagesAbout.vue?vue&type=template&id=700d4e1a&scoped=true"
import script from "./AdminPagesAbout.vue?vue&type=script&lang=js"
export * from "./AdminPagesAbout.vue?vue&type=script&lang=js"

import "./AdminPagesAbout.vue?vue&type=style&index=0&id=700d4e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700d4e1a"]])

export default __exports__